import React, {
  Component,
} from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import ScGridTable from "../../../components/display/table/gridTableCore";
import FormCore from "../../../components/display/form/formCore";
import monthPickerHoc from "../../../hoc/form/monthPickerHoc";
import { getStubStatuLogList, prefixFile } from "../../../fetch/fetchApi";
// 国际化切换语言

const defaultDate = moment();

@monthPickerHoc
// eslint-disable-next-line arrow-parens
@connect(state => state)
class stubStatusLog extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubStatusLog;
    this.state = {
      gridData: [],
      exportMes: this.internationalization.btn2, // '导出',
    };
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      month: defaultDate.format("YYYY-MM"),
      stubId: this.props.stubIdData,
      page: 1,
    };

    // 判断初始日期是否再同一个月分
    const month1 = moment(new Date()).subtract(7, "d").format("MM");
    const month2 = moment(new Date()).format("MM");
    this.dateFlag = (parseInt(month2) - parseInt(month1)) > 0;
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    }

    componentWillMount() {
      this.init();
    }

    init() {
      const momentFirst = this.dateFlag ? moment(`${moment(new Date()).format("YYYY-MM")}-01`) : moment(new Date()).subtract(7, "d");
      this.formConfig = {
        childItems: [
          //     {
          //     width: '100%',
          //     param: {
          //         name: 'month',
          //         type: 'object'
          //     },
          //     defaultValue: moment(new Date(), 'YYYY-MM'),
          //     required: !1,
          //     labelName: this.internationalization.title1,//'月份选择',
          //     format: this.props.format,
          //     plugin: this.props.monthPicker[0](this.internationalization.title1, 'month')
          //  },
          {
            type: "date",
            dateType: "rangeDate",
            placeholder: ["开始时间", "结束时间"],
            param: {
              name: "date",
              type: "array",
            },
            width: "240px",
            allowClear: false,
            defaultValue: [momentFirst, moment(new Date())],
            validator: { // 日期自定义校验规则
              vtype: "inOneMonth", // 校验名称
              range: 0,
              max_Val: 31,
            }, // 自定义校验规则
            labelName: "起止日期", // '订单结束时间:',
            required: !0,
          }, {
            type: "buttonGp", // 表单最终执行组
            buttonArr: [{
              btnType: "submit",
              text: this.internationalization.btn1, // '查询',
              // icon: 'search'
            }, {
              btnType: "button",
              text: this.internationalization.btn2, // '导出',
              icon: "export",
              handler: (e, param) => {
                this.exportData(param);
              },
            }],
          }], // 设置表单元素
        layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
        formTarget: "grid", // 表单提交类型，设置grid则为更新grid
        defaultParams: {
          stubId: this.query.stubId,
          // month: defaultDate.format("YYYYMM"),
          startTime: momentFirst.format("YYYYMMDD"),
          endTime: moment(new Date()).format("YYYYMMDD"),
        },
        autoLoadGrid: !0, // 设置为false不触发加载grid
        context: this,
        tableKey: "moduleStatusLog",
      };
      this.setState({
        tableConfig: {
          tableColumns: [{
            name: this.internationalization.title2, // '上报时间',
            key: "time",
            align: "center",
          }, {
            name: this.internationalization.title3, // '状态码',
            key: "statusCode",
          }, {
            name: this.internationalization.title4, // 状态信息',
            key: "statusName",
            colType: "tipCol",
            tipNum: 15,
          }],
          tableChange: () => {

          },
          tableParam: {
            pageCount: 10,
          },
          tableInfo: {
            hasRow: !1, // 是否显示checkbox
          },
          autoRefresh: !1, // 设置为true 直接加载grid数据
          dataApi: getStubStatuLogList,
          tableKey: "moduleStatusLog",
        },
      });
    }

    fetchApi = (params) => {
      let result = {
        ...params,
      };
      console.log(params);
      const date = params.date.split(",");
      if (params.date) {
        result = {
          ...result,
          // month: moment(date[0]).format('YYYYMM'),
          startTime: moment(date[0]).format("YYYYMMDD"),
          endTime: moment(date[1]).format("YYYYMMDD"),
        };
      }
      console.log(result);
      delete result.date;
      return result;
    };

    // 数据导出
    exportData(param) {
      const date = param.date.split(",");
      const excelUrl = `${prefixFile}/exportStubStatus.do`;
      const params = `stubId=${param.stubId}&startTime=${moment(date[0]).format("YYYYMMDD")}&endTime=${moment(date[1]).format("YYYYMMDD")}`;
      console.log(params);
      const ele = document.createElement("a");
      ele.download = encodeURI(`${excelUrl}?${params}`);
      ele.style.display = "none";
      ele.href = encodeURI(`${excelUrl}?${params}`);
      ele.target = "_blank"; // 针对 ie模式 的浏览器
      // 触发点击
      document.body.appendChild(ele);
      ele.click();
      // 然后移除
      document.body.removeChild(ele);
    }

    handleOrderDetailModalCancel = () => {
      this.setState({
        orderDetailVisible: false,
      });
    }

    render() {
      return (
        <div className="sc-page-content">
          <FormCore
            formConfig={this.formConfig}
            getInstance={this.props.getInstance}
            fetchApi={this.fetchApi} />
          <div className="page-panel no-table-footer" style={{ marginTop: 15 }}>
            <ScGridTable config={this.state.tableConfig} unTotalMode />
          </div>
        </div>
      );
    }
}

export default injectIntl(stubStatusLog);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubStatusLog.js